import Card from './Card';

export * from './Card';
export default Card;
